if (!customElements.get('quick-view-accessories')) {
    customElements.define(
        'quick-view-accessories',
        class QuickViewAccessories extends BasicModal {
            constructor() {
                super();

                this.listProducts();
                this.modal = this;
                this.changeContainerView();

                // 🚀 Sayfa scroll’unu kapat
                this.lockPageScroll();

                // 🚀 Modal kapanınca scroll’u geri aç
                this.unlockPageScrollOnClose();
                this.responsiveDestroy();
            }

            responsiveDestroy() {
                if (window.innerWidth < 1025) {
                    //mobile
                    document.querySelector('.accessories-type-desktop').style.display = 'none';

                } else {
                    //desktop
                    // document.querySelector('.accessories-mobile').remove();
                }
            }

            changeContainerView() {
                let mainAccessories = document.getElementById('main-accessories-desktop');
                if (window.innerWidth < 1025) {
                    mainAccessories = document.getElementById('main-accessories-mobile');
                    if (mainAccessories) {
                        mainAccessories.classList.remove('drawer--right');
                        if (!mainAccessories.classList.contains('drawer--bottom')) {
                            mainAccessories.classList.add('drawer--bottom');
                        }
                    }
                } else {
                    if (!mainAccessories.classList.contains('drawer--right')) {
                        mainAccessories.classList.add('drawer--right');
                    }
                    mainAccessories.classList.remove('drawer--bottom');
                }
            }

            listProducts() {
                const accessoriesButton = document.querySelector(".accessories button");
                if (accessoriesButton) {
                    function handleAccessoriesButtonClick(selector) {
                        const button = document.querySelector(selector);
                        if (!button) return;

                        button.addEventListener("click", () => {
                            const slider = document.querySelector(".accessories-container");
                            if (slider) {
                                const clonedSlider = slider.cloneNode(true);
                                if (window.innerWidth < 1025) {
                                    document.getElementById("products-accessories-mobile").innerHTML =
                                        clonedSlider.outerHTML;
                                } else {
                                    document.getElementById("products-accessories-desktop").innerHTML =
                                        clonedSlider.outerHTML;
                                }
                            }

                            // type seçimi
                            const wd =
                                window.innerWidth < 1025 ? '[type="mobile"]' : '[type="desktop"]';

                            // buy now button listener
                            document
                                .querySelectorAll("quick-view-accessories .product-card__buy-now-button")
                                .forEach((buyNowButton) => {
                                    buyNowButton.addEventListener("click", () => {
                                        const drawerCloseBtn = document.querySelector(
                                            `quick-view-accessories[active][open]${wd} .drawer__close-btn`
                                        );
                                        setTimeout(() => {
                                            if (drawerCloseBtn) drawerCloseBtn.click();
                                        }, 500);
                                    });
                                });
                        });
                    }

                    handleAccessoriesButtonClick(".accessories button");
                    handleAccessoriesButtonClick(".accessories-mobile button");
                }
            }

            lockPageScroll() {
                // Modal açıldığında body scroll’u kapat
                // document.body.classList.add('modal-open');
            }

            unlockPageScrollOnClose() {
                // Modal kapanınca body scroll’u geri aç
                const overlay = this.querySelector('.fixed-overlay');
                const closeBtn = this.querySelector('.drawer__close-btn');

                overlay?.addEventListener('click', () => {
                    document.body.classList.remove('modal-open');
                });
                closeBtn?.addEventListener('click', () => {
                    document.body.classList.remove('modal-open');
                });
            }
        }
    );
}
